/* eslint-disable no-undef */
import axios from 'axios'
import { data } from './mockup-data'
import * as _ from 'lodash'
import store from "@/store";

let baseUrl = 'https://licensing.api.production.boundlessdigital.com/api/v1/';
let $http;
const config = {
  address: baseUrl,
  port: '',
  basePath: '',
  axiosConfig: {
    baseURL: baseUrl,
    headers: {},
    withCredentials: true,
    crossDomain: true,
  },
  getEndpointUrl() {
    return this.address + (this.basePath ? this.basePath : '')
  },
}

function reloadAxios(loadToken = true) {
  // Load the user authorization token
  let token;
  let updatedConfig = JSON.parse(JSON.stringify(config));
  if (loadToken) {
    const storedUserInfo = localStorage.getItem('userInfo') ?? sessionStorage.getItem('userInfo');
    if (storedUserInfo) {
      token = JSON.parse(storedUserInfo);
      updatedConfig.axiosConfig.headers['authorization'] = `Token ${token.uid}`;
    }
  }

  $http = axios.create(updatedConfig.axiosConfig)
  if (token) {
    $http.defaults.headers.common['authorization'] = `Token ${token.uid}`;
  }
}

reloadAxios();

const handleInvalidTokenError = (response, reject) => {
  if (response?.response?.data?.detail === 'Invalid token.') {
    store.dispatch('signOut').then(() => {
      reject(response);
    });
  }
  reject(response);
}

let sendPost = (url, payload, headers = null) => {
  return new Promise((resolve, reject) => {
    $http
      .post(url, payload, headers)
      .then((handleSuccess) => {
        resolve(handleSuccess.data)
      })
      .catch((handleError) => {
        handleInvalidTokenError(handleError, reject);
      })
  })
}

let sendPut = (url, payload, headers = null) => {
  return new Promise((resolve, reject) => {
    $http
      .put(url, payload, headers)
      .then((handleSuccess) => {
        resolve(handleSuccess.data)
      })
      .catch((handleError) => {
        handleInvalidTokenError(handleError, reject);
      })
  })
}

const getMockupData = (url, payload = {}) => {
  let key = ''
  const slugs = url.split('/')
  for (const slug of slugs) {
    key += key ? _.capitalize(slug) : slug
  }

  if (payload.period) {
    key = `${key}${payload.period}`
  }

  const mockData = data[key] || []
  let result = []

  const { offset, limit } = payload
  if (offset != undefined && limit !== undefined) {
    result = mockData.filter((item, index) => index >= offset && index < offset + limit)
  } else {
    result = mockData
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        count: mockData.length,
        results: result,
      })
    }, 2000)
  })
}

let sendGet = (url, payload) => {
  const themeName = localStorage.getItem('theme') || ''

  if (themeName === 'demo') {
    return getMockupData(url, payload)
  }

  return new Promise((resolve, reject) => {
    $http
      .get(url, { params: payload })
      .then((handleSuccess) => {
        resolve(handleSuccess.data)
      })
      .catch((handleError) => {
        handleInvalidTokenError(handleError, reject);
      })
  })
}

let sendDelete = (url, payload) => {
  return new Promise((resolve, reject) => {
    $http
      .delete(url, { data: payload })
      .then((handleSuccess) => {
        resolve(handleSuccess.data)
      })
      .catch((handleError) => {
        handleInvalidTokenError(handleError, reject);
      })
  })
}

export default config

export { config }

export { sendPost }

export { sendPut }

export { sendGet }

export { sendDelete }

export { reloadAxios }
